import React, { useEffect, useState } from "react";
import {
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
} from "@mui/material";
import LoadingCircle from "../LayoutComponents/LoadingCircle";

export default function CustomDropdown({
  session,
  value,
  entityName,
  entityIdField,
  setEntity,
  style,
  label,
  error,
  disabled,
  request,
  setSector,
  helperText
}) {
  const [entities, setEntities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEntities = async () => {
      try {
        const res = await request(session?.token);
        setEntities(res.data || []);
      } catch (error) {
        console.error("Error fetching " + entityName, error);
      } finally {
        setLoading(false);
      }
    };

    if (session?.token) {
      fetchEntities();
    }
  }, [session?.token, entityName, request]);

  const handleChange = (event) => {
    const rawValue = event.target.value;
    const selectedId = rawValue !== "" && !isNaN(rawValue) ? Number(rawValue) : null;

    setEntity(selectedId);

    if (entityIdField === "industryId" && setSector) {
      const selectedEntity = entities.find(
        (e) => Number(e[entityIdField]) === selectedId
      );

      if (selectedEntity?.sector?.sectorId) {
        setSector(Number(selectedEntity.sector.sectorId));
      } else {
        setSector(null);
      }
    }
  };

  return loading ? (
    <LoadingCircle size={20} />
  ) : (
    <FormControl fullWidth disabled={disabled} sx={style} error={!!error}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value !== null && value !== undefined ? Number(value) : ""}
        label={label}
        onChange={handleChange}
        variant='standard'
      >
        <MenuItem disabled value="">
          {label}
        </MenuItem>
        {entities?.sort((a, b) => a[entityName]?.localeCompare(b[entityName]))
          .map((entity) => (
            <MenuItem
              key={Number(entity[entityIdField])}
              value={Number(entity[entityIdField])}
            >
              {entity[entityName]}
            </MenuItem>
          ))}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}
